import React, { useEffect, useState, useRef } from "react";

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/navigation-prev.svg";
import { ReactComponent as SuccessIcon } from "../../assets/svg/success.svg";
import { ReactComponent as ErrorIcon } from "../../assets/svg/close-red.svg";
import RoomImage from "../../assets/png/room-view-image.png";
import { ReactComponent as ReportIcon } from "../../assets/svg/report-icon.svg";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parse } from "date-fns";
import axios from "axios";
import { Form, Button, Container, InputGroup, Toast, ToastContainer } from "react-bootstrap";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../common/Header.js";
import { getCookie } from "../getcookie.js";
import LoaderModal from "../common/Loader.js";
import SearchWithAPI from "../searchbox/searchbox";
import { useGlobal } from "../../GlobalContext.js";

export default function Report() {
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const scrollRefs = useRef();

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    alert(`Submitted Value: ${emailInputValue}`);
  };

  const [meetingRoomDetails, setMeetingRoom] = useState({});
  const [isShowError, setShowError] = useState(false);
  const [isProceed, setProceed] = useState(false);
  const [isConfirmBooking, setConfirmBooking] = useState(false);

  const [titleInputValue, setTitleInputValue] = useState("");
  const [companyInputValue, setCompanyInputValue] = useState("");
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [emailInputValue, setEmailInputValue] = useState("");
  const handleTitleChange = (event) => {
    setTitleInputValue(event.target.value); // Update state with input value
  };

  const [selectedCategory, setCategoryValue] = useState("");
  const [selectedSlot, setSlotValue] = useState("30 mins");
  const [selectedBookId, setBookId] = useState([]);

  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openModal = (id) => {
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [availableList, setAvailable] = useState(["Ac", "Projector", "TV & Speaker"]);
  const [inviteEmails, setInviteEmail] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [officeOption, setOfficeOption] = useState(null);
  const [floorOption, setFloorOption] = useState(null);
  const [floorSearchUrl, setFloorSearchUrl] = useState("");
  const [roomOption, setRoomOption] = useState(null);
  const [employeeOption, setEmployeeOption] = useState(null);
  const [roomSearchUrl, setRoomSearchUrl] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const menuBoxInactive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center" };
  const menuBoxActive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234" };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#842234" };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: "#1E1E1E" };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };
  const title = { fontSize: "32px", fontWeight: "700", color: "#1E1E1E" };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: "#81878C" };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: "#1E1E1E" };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: "#81878C", marginTop: "8px" };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: "#81878C", marginBottom: "8px" };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: "#21272C" };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: "#1E1E1E" };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: "#842234" };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: "#1E1E1E" };
  const officeTitle = { marginTop: "16px", marginBottom: "8px", fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#1E1E1E" };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 0.8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "328px",
      height: "229px",
      textAlign: "center",
    },
  };

  const handleLocationDropdownChange = (option) => {
    console.log(option);
    setOfficeOption(option);
    setFloorOption(null);
    setRoomOption(null);
    setFloorSearchUrl(apiUrl + "get_floors/" + option.value);
    setRoomSearchUrl(apiUrl + "get_room?office_id=" + option.value + "&floor_no=");
  };
  const handleFloorDropdownChange = (option) => {
    setFloorOption(option);
    setRoomOption(null);
    setRoomSearchUrl(apiUrl + "get_room?office_id=" + officeOption.value + "&floor_no=" + option.value);
  };
  const handleRoomDropdownChange = (option) => {
    setRoomOption(option);
  };
  const handleEmployeeDropdownChange = (option) => {
    setEmployeeOption(option);
  };
  useEffect(() => {
    setSelectedMenu("Report");
    console.log({ selectedMenu })
  }, []);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(apiUrl + `booking/`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",

          "Access-Control-Allow-Origin": "*", // Required for CORS support to work
          Authorization: getCookie("mawalog"),
        },
      });

      if (response.data.success === true) {
        console.log("booking:", response.data.booking);
        setMeetingRoom(response.data.booking);
        setAvailable(response.data.booking.available ?? []);
        setInviteEmail(response.data.booking.emails ?? []);
      }
      console.log("Room List:", roomList);
      console.log("Room List Length:", roomList.length);
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const cancelBooking = async (id) => {
    setErrorMessage("");
    setLoading(true);
    setError(null);

    try {
      const data = {};
      const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios.put(apiUrl + `cancel_booking/` + id, data, { headers: headers }).catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 500) {
            setErrorMessage(error.response.data.message);
          }
        } else {
          console.error("Request failed:", error.message);
        }
      });

      // const data = await response.json();
      if (response.data.success === true) {
        fetchOptions();
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkInOutMeeting = async (id, status) => {
    setErrorMessage("");
    setLoading(true);
    setError(null);

    try {
      const data = {};
      const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios
        .put(apiUrl + (status === "Pending" ? "check_in_booking" : "check_out_booking") + "/" + id, data, { headers: headers })
        .then((response) => {
          console.log("Response status:", response.status); // Check actual status
          console.log("Response data:", response.data);
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 500) {
              setErrorMessage(error.response.data.message);
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });
      console.log("response.status", response.status);
      console.log("message", response.data.message);
      // const data = await response.json();
      if (response.status === 200) {
        if (response.data.success === true) {
          fetchOptions();
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  const [showFromDatePicker, setShowFromDatePicker] = useState(false);
  const [showToDatePicker, setShowToDatePicker] = useState(false);
  const handleFromDateChange = (date) => {
    setFromDate(date);

    setShowFromDatePicker(false);
  };
  const handleToDateChange = (date) => {
    setToDate(date);

    setShowToDatePicker(false);
  };
  function formatDate(inputDate) {
    try {
      if (inputDate !== undefined) {
        // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const handleClickOutside = (event) => {
    if (fromDateRef.current && !fromDateRef.current.contains(event.target)) {
      setShowFromDatePicker(false);
    }
    if (toDateRef.current && !toDateRef.current.contains(event.target)) {
      setShowToDatePicker(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const downloadReport = async () => {
    //  setCustomSlotErrorMessage({date:'',  from:'',  to:'',});
    try {
      const data = {
        room_id: roomOption != null ? roomOption.value : "",
        office_id: officeOption != null ? officeOption.value : "",
        floor: floorOption != null ? floorOption.value : "",
        emp_id: employeeOption != null ? employeeOption.value : "",
        from_date: fromDate,
        to_date: toDate,
      };
      const headers = {
        "Content-Type": "application/json;",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios
        .post(apiUrl + "report", data, { headers: headers })
        .then((response) => {
          if (response.statusCode === 400) {
          } else {
            if (response.data.success === true) {
              const base64String = response.data.base64; // Truncated for brevity
              const fileName = "Report_" + new Date().getTime() + ".xlsx";

              // Convert Base64 to Blob
              const binary = atob(base64String);
              const array = [];
              for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
              }
              const blob = new Blob([new Uint8Array(array)], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              // Create a link and trigger download
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            setSnackbarMessage(response.data.message);
            setSnackbarStatus(response.data.success);
            handleSnackbarShow();
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
            setSnackbarMessage(error.response.data.message);
            setSnackbarStatus(error.response.data.success);
            handleSnackbarShow();
          } else {
            console.error("Request failed:", error.message);
          }
        });
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {/*  <Header selectedTab={'Report'}/> */}

      <Row className="flex-wrap px-3" style={{ height: "calc(100vh - 68px)", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: "center" }}>
        <Col xl={10} style={{ marginTop: "16px", borderRadius: "24px", padding: "32px", background: "#ffffff" }}>
          <Row>
            <Col sm={3} className="d-none d-lg-block">
              <div style={{ height: "362px" }}>
                <ReportIcon />
              </div>
            </Col>
            <Col md={12} lg={9} style={{ justifyContent: "center" }}>
              <div style={{ fontSize: "20px", fontWeight: "700", color: "#212129" }}>Get your report now</div>
              <Row style={{ marginTop: "8px" }}>
                <Col sm={6}>
                  <div style={{ paddingBottom: "4px", fontSize: "13px", fontWeight: "400", color: "#21272C" }}>Office</div>
                  <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={apiUrl + `get_office`} placeholder={"Office"} selectedValue={officeOption !== null ? officeOption.label : ""} selectedOption={officeOption} />
                  <Form.Text style={{ textAlign: "start" }} className="text-muted">
                    {errorMessage.office_id !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.office_id}</div>}
                  </Form.Text>
                </Col>
                <Col sm={6} className="mt-2 mt-lg-0">
                  <div style={{ paddingBottom: "4px", fontSize: "13px", fontWeight: "400", color: "#21272C" }}>Floor </div>
                  <SearchWithAPI onDropdownChange={handleFloorDropdownChange} apiUrl={floorSearchUrl} placeholder={"Floor"} selectedValue={floorOption != null ? floorOption.label : ""} selectedOption={floorOption} />
                  <Form.Text style={{ textAlign: "start" }} className="text-muted">
                    {errorMessage.floor_no !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.floor_no}</div>}
                  </Form.Text>
                </Col>
              </Row>

              <Row style={{ marginTop: "16px" }}>
                <Col sm={6}>
                  <div style={{ paddingBottom: "4px", fontSize: "13px", fontWeight: "400", color: "#21272C" }}>Room</div>
                  <SearchWithAPI onDropdownChange={handleRoomDropdownChange} apiUrl={roomSearchUrl} placeholder={"Room"} selectedValue={roomOption !== null ? roomOption.label : ""} selectedOption={roomOption} />
                  <Form.Text style={{ textAlign: "start" }} className="text-muted">
                    {errorMessage.office_id !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.office_id}</div>}
                  </Form.Text>
                </Col>
                <Col sm={6} className="mt-2 mt-lg-0">
                  <div style={{ paddingBottom: "4px", fontSize: "13px", fontWeight: "400", color: "#21272C" }}>Employee</div>
                  <SearchWithAPI onDropdownChange={handleEmployeeDropdownChange} apiUrl={adminApiUrl + `get_employee`} placeholder={"Employee"} selectedValue={employeeOption != null ? employeeOption.label : ""} selectedOption={employeeOption} />
                  <Form.Text style={{ textAlign: "start" }} className="text-muted">
                    {errorMessage.floor_no !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.floor_no}</div>}
                  </Form.Text>
                </Col>
              </Row>

              <Row style={{ marginTop: "16px" }}>
                <Col sm={6}>
                  <div style={{ paddingBottom: "4px", fontSize: "13px", fontWeight: "400", color: "#21272C" }}>From Date</div>
                  <input
                    id="from_date"
                    type="date"
                    value={fromDate}
                    onChange={(event) => {
                      setFromDate(event.target.value);
                    }}
                    style={{
                      height: "40px",
                      borderRadius: "10px",
                      border: "0.7px solid #E5E5E5",
                      padding: "16px",
                    }}
                    class="date-picker w-100"
                    placeholder="DD-MM-YYYY"
                  />
                  {/*   <div style={{position: 'relative',  height:"40px" }}>
                    
                    <div style={{ display: 'flex', alignItems: 'center', border: '0.7px solid #E5E5E5', borderRadius: '8px', padding: '10px 12px' }}>
                      <input
                        type="text"
                        value={fromDate ?formatDate(fromDate.toLocaleDateString()) : ''}
                        onClick={() => setShowFromDatePicker(!showFromDatePicker)}
                        readOnly
                        style={{ flex: 1, border: 'none', outline: 'none', cursor: 'pointer' }}
                        placeholder="Select a date"
                      />
                      <CalendarIcon style={{ cursor: 'pointer', color: '#842234' }} onClick={() => setShowFromDatePicker(!showFromDatePicker)} />
                    </div>
              
                  
                    {showFromDatePicker && (
                      <div ref={fromDateRef} style={{ position: "absolute", bottom: "10px", right: "0", zIndex: 9999, background: "#fff", border: "1px solid #ccc", borderRadius: "4px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)" }}>
                        <DayPicker mode="single" selected={fromDate} onSelect={handleFromDateChange} />
                      </div>
                    )}
                  </div> */}
                </Col>
                <Col sm={6} className="mt-2 mt-lg-0">
                  <div style={{ paddingBottom: "4px", fontSize: "13px", fontWeight: "400", color: "#21272C" }}>To Date</div>
                  <input
                    id="to_date"
                    type="date"
                    value={toDate}
                    onChange={(event) => {
                      setToDate(event.target.value);
                    }}
                    style={{
                      height: "40px",
                      borderRadius: "10px",
                      border: "0.7px solid #E5E5E5",
                      padding: "16px",
                    }}
                    class="date-picker w-100"
                    placeholder="DD-MM-YYYY"
                  />
                  {/* <div style={{position: 'relative',  height:"40px" }}>
                   
                    {showToDatePicker && (
                      <div ref={toDateRef} style={{ position: 'absolute', bottom:'10px', 
                        right: '0', zIndex: 9999, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>
                        <DayPicker mode="single" selected={toDate} onSelect={handleToDateChange} />
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', border: '0.7px solid #E5E5E5', borderRadius: '8px', padding: '10px 12px' }}>
                      <input
                        type="text"
                        value={toDate ?formatDate(toDate.toLocaleDateString()) : ''}
                        onClick={() => setShowToDatePicker(!showToDatePicker)}
                        readOnly
                        style={{ flex: 1, border: 'none', outline: 'none', cursor: 'pointer' }}
                        placeholder="Select a date"
                      />
                      <CalendarIcon style={{ cursor: 'pointer', color: '#842234' }} onClick={() => setShowToDatePicker(!showToDatePicker)} />
                    </div>                   
                  </div>  */}
                </Col>
              </Row>
              <Row style={{ marginTop: "16px", display: "flex", alignItems: "center", justifyContent: "end" }}>
                <div
                  onClick={(e) => {
                    setOfficeOption(null);
                    setFloorOption(null);
                    setFloorSearchUrl(null);
                    setRoomOption(null);
                    setRoomSearchUrl(null);
                    setEmployeeOption(null);
                    setFromDate(null);
                    setToDate(null);
                  }}
                  style={{ cursor: "pointer", width: "176px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#FFFFFF", border: "0.6px solid #E5E5E5" }}>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#1E1E1E" }}>Clear</div>
                </div>
                <div
                  onClick={() => {
                    downloadReport();
                  }}
                  style={{ cursor: "pointer", width: "176px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#FFFFFF" }}>Export</div>
                </div>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>
  );
}
